/* eslint-disable max-classes-per-file */
// tslint:disable-next-line:max-classes-per-file
import { Action } from '@ngrx/store';
import { CustomerTypes } from 'src/app/models/delivery.model';
/** CustomerSupportActionTypes */
export enum CustomerSupportActionTypes {
    STORE_HOTLINE_NUMBER = 'STORE_HOTLINE_NUMBER',
    SET_HOTLINE_NUMBER = 'SET_HOTLINE_NUMBER',
    CUSTOMER_SUPPORT_CONTRACT_CANCELLATION= 'CUSTOMER_SUPPORT_CONTRACT_CANCELLATION',
    STORE_CUSTOMER_SUPPORT_MESSAGES = 'STORE_CUSTOMER_SUPPORT_MESSAGES',
    STORE_CALLBACK_LINK_IDENTIFER = 'STORE_CALLBACK_LINK_IDENTIFER',
    CUSTOMER_SUPPORT_REVIEW_ITEMS= 'CUSTOMER_SUPPORT_REVIEW_ITEMS',
}
/** CustomerSupportContractCancellation */
export class CustomerSupportContractCancellation implements Action {

    /** type */
    public readonly type = CustomerSupportActionTypes.CUSTOMER_SUPPORT_CONTRACT_CANCELLATION;

    public constructor (public payload: {
        /** customer type */
        customerType: CustomerTypes,
    }) { }
}

/** CustomerSupportReviewItems */
export class CustomerSupportReviewItems implements Action {

    /** type */
    public readonly type = CustomerSupportActionTypes.CUSTOMER_SUPPORT_REVIEW_ITEMS;
    /**
     *
     * @param payload
     */
    public constructor (public payload: {
        /** customer type */
        customerType: CustomerTypes,
    }) { }
}
/** SetHotlineNumber */
export class SetHotlineNumber implements Action {
    /** type */
    public readonly type = CustomerSupportActionTypes.SET_HOTLINE_NUMBER;
    /**
     *
     * @param payload
     */
    public constructor (public payload: {
        /** cms path */
        cmsPath: string,
        /** sales channel */
        salesChannel: string}) { }
}
/** StoreHotlineNumber */
export class StoreHotlineNumber implements Action {
    /** type */
    public readonly type = CustomerSupportActionTypes.STORE_HOTLINE_NUMBER;
    /**
     *
     * @param payload
     */
    public constructor (public payload: {
        /** hotline number */
        hotlineNumber: string}) { }
}
/** StoreCustomerSupportMessage */
export class StoreCustomerSupportMessage implements Action {
    /** type */
    public readonly type = CustomerSupportActionTypes.STORE_CUSTOMER_SUPPORT_MESSAGES;
    /**
     *
     * @param payload
     */
    public constructor (public payload: {
        /** sms message */
        smsMessage: string,
        /** whats app message */
        whatsappMessage: string }) { }
}
/** StoreCallbackLinkIdentifer */
export class StoreCallbackLinkIdentifer implements Action {
    /** type */
    public readonly type = CustomerSupportActionTypes.STORE_CALLBACK_LINK_IDENTIFER;
    /**
     *
     * @param payload
     */
    public constructor (public payload: {
        /** thema */
        thema: string,
        /** icmp */
        icmp: string}) { }
}
/** CustomerSupportAction */
export type CustomerSupportAction = SetHotlineNumber | StoreHotlineNumber | CustomerSupportContractCancellation | StoreCustomerSupportMessage | StoreCallbackLinkIdentifer;
